<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card header="<i class='fa fa-star'></i> Pendanaan Dashboard">
            <button type="button" @click="showModal" class="btn btn-outline-primary">Tambah Pendanaan</button>
            <br></br>
            <div v-if="isLoading" > 
            <center>
              <v-pulse></v-pulse>
            </center>
            </div>
            <div v-else class="table-responsive">

            <table class="table table-striped table-bordered table-hover" >
                <thead>
                  <tr>
                      <th>No</th> 
                      <th>Judul</th>
                      <th>Konten</th>
                      <th>Gambar</th>
                      <th>Action</th>
                  </tr>
                </thead>
                <tbody v-if="fundings.length > 0">
                    <tr v-for="(value,index) in fundings" :key="index">
                        <td>{{index+1}}</td>
                        <td>{{value.title}}</td>
                        <td>{{value.content}}</td>
                        <td>
                            <b-img class="imageFile" thumbnail fluid :src="'https://res.cloudinary.com/wahyupermadie/image/fetch/c_fill,g_auto:face,h_120,w_120,fl_force_strip.progressive/f_webp/https://hackathon.futnet.id/funding/'+value.foto" alt="Thumbnail" />
                        </td>
                        <td>
                          <router-link :to="{ name:'FundingDetail', params:{id: value.id}}" >
                            <button type="button" class="btn btn-xs btn-outline-success"><span class="fa fa-search"></span></button>
                          </router-link>
                        </td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <td colspan="5">
                        <center>
                            Tidak Ada Data
                        </center>
                    </td>
                </tbody>
              </table>
            </div>
          </b-card>
        </b-col><!--/.col-->
      </b-row><!--/.row-->
      <b-modal title="Buat Pendanaan" class="modal-primary" v-model="isModalVisible" @ok="addFunding">
        <b-form enctype="multipart/form-data">
            <b-form-group
                label="Nama Pendanaan"
                label-for="nama">
            <b-form-input v-model="funding.title" required id="nama" type="text" placeholder="Nama Pendanaan" autocomplete="Nama"></b-form-input>
            </b-form-group>
            <b-form-group
                label="Tanggal Mulai"
                label-for="tanggalmulai">
                <b-form-input 
                v-model="funding.start_date"
                id="tanggallahir" 
                type="date" 
                placeholder="Tanggal Mulai" 
                required 
                autocomplete="tanggallahir">
                </b-form-input>
            </b-form-group>
            <b-form-group
                label="Deskripsi"
                label-for="deskripsi">
                <textarea v-model="funding.content" required class="form-control" placeholder="Deskripsi Pendanaan" rows="5" id="deskripsi"></textarea>
            </b-form-group>
            <b-form-group>
                <b-input-group class="mb-4">
                  <b-form-file name="filefunding" id="filefunding"  placeholder="Choose funding logo..."></b-form-file>
                </b-input-group>
            </b-form-group>
        </b-form>
      </b-modal>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import {getCache,storedCache} from '@/cache'
import constant from '../../utils/constant.js';
export default {
  data () {
    return {
        isLoading: true,
        isModalVisible: false,
        selected : null,
        funding : {},
        fundings:[]
    }
  },
  created(){
     this.getFunding()
  },
  beforeMount()
  {
    
  },
  watch: {
    '$route' : 'getFunding'
  },
  methods:{
      openSpinner()
      {
        this.isLoading = true
      },
      closeSpinner()
      {
        this.isLoading = false
      },
      getFunding()
      {
        this.openSpinner()
        const community_id = localStorage.getItem('user_id');
        const token = localStorage.getItem(`user_token`);
        axios.get(constant._BASE_URL+"funding",{
            headers:{
                'Content-type': 'application/json',
                'Authorization' : 'Bearer '+token,
            }
        }).then(response =>{
            storedCache(`funding`+community_id, response.data)
            this.fundings = getCache(`funding`+community_id)
            this.closeSpinner()
        }).catch(error => {
            console.log(error)
            this.fundings = getCache(`funding`+community_id)
            this.closeSpinner()
        });
      },
      showModal() {
        this.isModalVisible = true;
      },
      closeModal() {
        this.isModalVisible = false;
      },
      addFunding(e)
      {
        e.preventDefault()
        const community_id = localStorage.getItem('user_id');
        const token = localStorage.getItem(`user_token`);
        let formData = new FormData()
        var foto = document.getElementById('filefunding')
        formData.append('foto', foto.files[0])
        formData.append('content', this.funding.content)
        formData.append('start_date', this.funding.start_date)
        formData.append('deskripsi',this.funding.deskripsi)
        formData.append('title',this.funding.title)
        axios.post(constant._BASE_URL+"funding",formData,{
            headers:{
                'Content-type': 'application/json',
                'Authorization' : 'Bearer '+token,
            }
        }).then(response =>{
            this.getFunding()
        }).catch(error => {
            alert(error)
        })
        this.closeModal()
      }
  }
}
</script>
<style scoped>
.imageFile {
  height: 150px;
}
.imageHome {
  width: 30%;
  display: inline-block;
  margin-left: 0dp;
  margin-right: 0dp;
}
</style>



// WEBPACK FOOTER //
// src/components/funding/Funding.vue